import { reactive } from 'vue';
import { getSlovarList, getBookMeta, getBookData, getCardData } from '@/service/nsi-service';
import { getDepartmentsWithOfficials } from '@/service/admin-service';

const gridMessageOptions = [
    { id: 'NOT_BOOK', label: 'Нет открытых справочников' },
    { id: 'IS_GROUP', label: 'Выбрана группа справочников' },
    { id: 'NOT_FOUND', label: 'Справочник не подключен' },
    { id: 'IS_FORM', label: 'Форма находится в разработке' },
    { id: 'IS_TABLE', label: 'Загрузка таблицы (таблицы пока в разработке)' },
];

const types = new Map([
    ['S', 'string'],
    ['C', 'combo'],
    ['N', 'number'],
    ['B', 'boolean'],
]);

const state = reactive({
    slovarList: [],
    currentEditorType: 'NOT_BOOK',
    selectedCode: null,
    currentBookMeta: {},
    currentBookData: [],
    departmentsWithOfficialsList: [],
    initialSelectedRowKey: null,
    dataErrorMessage: null,
    isDataLoaded: false,
    cardData: {},
});

const setSlovarList = async () => {
    const args = {};
    const items = await getSlovarList(args);
    if (items) state.slovarList = items;
};

const setBookMetaAndData = async code => {
    const { success, data, errors } = await getBookData(code);

    success
        ? ((state.currentBookData = data), (state.dataErrorMessage = null))
        : ((state.dataErrorMessage = errors[0].message), (state.currentBookData = {}));

    const bookMeta = await getBookMeta(code);
    if (state.currentEditorType === 'IS_TABLE') {
        state.currentBookMeta =
            bookMeta.treeKeys.length > 0 ? processTreeListMeta(bookMeta) : processGridMeta(bookMeta);
    } else {
        return;
    }
};

const setDepartmentsWithOfficials = async kod_ecls => {
    const items = await getDepartmentsWithOfficials(kod_ecls);
    if (items) {
        state.departmentsWithOfficialsList = items;
    }
};

const processTreeListMeta = ({ tabAccess, treeKeys, code, columns }) => {
    const { allowAdding, allowUpdating, enableDeleting } = processEditingPermissions(tabAccess);
    const processedMeta = {
        isTree: true,
        keyExpr: treeKeys[0],
        parentIdExpr: treeKeys[1],
        name_tbl: code,
        wordWrapEnabled: true,
        rootValue: null,
        allowAdding,
        allowUpdating,
        enableDeleting,
        columns: processColumns(columns),
    };

    return processedMeta;
};

const processGridMeta = ({ tabAccess, code, columns, refNames }) => {
    const { allowAdding, allowUpdating, enableDeleting } = processEditingPermissions(tabAccess);
    const processedMeta = {
        isTree: false,
        keyExpr: columns[0].name,
        name_tbl: code,
        wordWrapEnabled: true,
        allowAdding,
        allowUpdating,
        enableDeleting,
        refNames,
        columns: processColumns(columns),
    };
    
    return processedMeta;
};

const processEditingPermissions = ({ upd, ins, del }) => {
    return {
        allowAdding: ins,
        allowUpdating: upd,
        enableDeleting: del,
    };
};

const processColumns = columns => {
    return columns.map(column => {
        const { title, name, type, readOnly, refNames } = column;
        if (refNames?.length > 0) {
            const [valueExpr, displayExpr] = refNames;
            return {
                caption: title,
                dataField: name,
                dataType: types.get(type),
                allowEditing: false,
                cellTemplate: 'dropDown',
                lookupData: {
                    dataSource: state.currentBookData?.[name],
                    valueExpr,
                    displayExpr,
                    refNames,
                    readOnly,
                },
            };
        }
        
        return {
            caption: title,
            dataField: name,
            dataType: types.get(type),
            allowEditing: !readOnly,
        };
    });
};

const setEditorType = type => {
    const includesType = type => gridMessageOptions.find(item => item.id === type);
    if (includesType(type)) state.currentEditorType = type;
};

const getEditorMessage = () => gridMessageOptions.find(item => item.id === state.currentEditorType)?.label;

const getCompanyStructureCard = async (id, type) => {
    const res = await getCardData(id, type);
    state.cardData = res?.items || {};
    return state.cardData;
};

export default {
    state,
    setSlovarList,
    setEditorType,
    getEditorMessage,
    setBookMetaAndData,
    setDepartmentsWithOfficials,
    getCompanyStructureCard,
};
